export default "__VITE_ASSET__CmUJ1KJp__"